<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { computed } from 'vue'
import starterPackImage from '@/assets/images/shop-button.webp'
import afterStarterPackImage from '@/assets/images/shop-button.webp'
import ShopBadge from '@/components/ShopBadge.vue'
import starterPackValueImage from '@/assets/images/shop-badge-1000.png'
import afterStarterPackValueImage from '@/assets/images/shop-badge-500.png'
import turboStarterPackValueImage from '@/assets/images/shop-badge-400.png'
import { useLimitedTimeOffers } from '@/composables/game/ecommerce'

const props = withDefaults(defineProps<{
  coolDown?: number
  label?: string
  labelClass?: string
  isStarter: boolean
}>(), {
  coolDown: 0,
  label: undefined,
  labelClass: '',
})

const { afterStarterPackDuration } = useLimitedTimeOffers()
const hasCooldown = computed(() => props.coolDown > 0)

const valueImage = computed(() => {
  if (props.isStarter) return starterPackValueImage
  return hasCooldown.value ? afterStarterPackValueImage : turboStarterPackValueImage
})
</script>

<template>
  <HomeButton
    :label="label"
    :show-sparkle="true"
    :countdown="hasCooldown ? { value: afterStarterPackDuration - coolDown, dangerThreshold: 3600 * 3 } : undefined"
  >
    <template #badge-custom>
      <ShopBadge :value-image="valueImage" />
    </template>
    <img
      class="size-full object-cover"
      :src="isStarter ? starterPackImage : afterStarterPackImage"
    >
  </HomeButton>
</template>
